export const TRULYINBOX_V2_URL = 'https://my.trulyinbox.com/';

export const TRULYINBOX_V2_REGISTER_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://my.trulyinbox.com/register'
    : 'https://normav2.trulyinbox.com/register';

export const redirectToV2 = (): void => {
  window.location.href = TRULYINBOX_V2_URL;
};
